let audioContext = null;
let activeSources = 0;
let suspendTimeout = null;

const bufferCache = new Map();

function getAudioContext() {
    if (!audioContext) {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) {
            return null;
        }
        audioContext = new AudioContextClass();
    }
    return audioContext;
}

function releaseWhenIdle() {
    if (suspendTimeout) {
        clearTimeout(suspendTimeout);
    }
    // Small delay so back-to-back sounds don't thrash resume/suspend.
    suspendTimeout = setTimeout(() => {
        suspendTimeout = null;
        if (activeSources <= 0 && audioContext && audioContext.state === 'running') {
            audioContext.suspend().catch(() => { });
        }
    }, 500);
}

function unlockAudio() {
    const context = getAudioContext();
    if (context && context.state === 'suspended') {
        context.resume()
            .then(() => context.suspend())
            .catch(() => { });
    }
    document.removeEventListener('click', unlockAudio);
}

document.addEventListener('click', unlockAudio);

async function loadBuffer(context, src) {
    if (bufferCache.has(src)) {
        return bufferCache.get(src);
    }

    const response = await fetch(src);
    const arrayBuffer = await response.arrayBuffer();
    const audioBuffer = await context.decodeAudioData(arrayBuffer);
    bufferCache.set(src, audioBuffer);
    return audioBuffer;
}

export const playSound = async (src) => {
    const context = getAudioContext();
    if (!context) {
        return;
    }

    try {
        const buffer = await loadBuffer(context, src);

        if (context.state === 'suspended') {
            await context.resume();
        }
        // If it couldn't start (autoplay policy before any user gesture), bail.
        if (context.state !== 'running') {
            return;
        }

        const source = context.createBufferSource();
        source.buffer = buffer;
        source.connect(context.destination);

        activeSources += 1;
        source.onended = () => {
            activeSources = Math.max(0, activeSources - 1);
            if (activeSources === 0) {
                releaseWhenIdle();
            }
        };

        source.start(0);
    } catch {
        // Ignore playback/decoding errors (unsupported format, network, etc.).
    }
}
